import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import { Text, TextTypes, Title, TitleTypes } from 'modules/ui';

import authorPlaceholder from '../../../../../../static/images/blog/author_placeholder.png';
import { PostAuthorLink } from '../../PostAuthorLink';
import type { BlogPostDetail } from '../../../types';

import * as felaRules from './AuthorBio.rules';

export interface AuthorBioProps {
    author: BlogPostDetail['author'];
}

export const AuthorBio = ({ author }: AuthorBioProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <div className={styles.container}>
            <img
                alt={author.displayName}
                src={author.photo?.formats?.thumbnail?.url ?? author.photo?.url ?? authorPlaceholder}
                className={styles.image}
            />
            <div className={styles.textContainer}>
                {/* @ts-expect-error */}
                <Title as={TitleTypes.H5} extend={{ title: rules.extendNameText }}>
                    <PostAuthorLink author={author} extend={{ link: rules.extendLink }} />
                </Title>
                {/* @ts-expect-error */}
                {author.role && <Text extend={{ text: rules.extendRoleText }}>{author.role}</Text>}
                {author.description && (
                    // @ts-expect-error
                    <Text type={TextTypes.NORMAL}>{author.description}</Text>
                )}
            </div>
        </div>
    );
};
